<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RegisterModalContent from '@/components/DailyReportEdit/Split/RegisterModalContent.vue';
import RegisterModal from '@/components/Common/RegisterModal.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: boolean
  title: string
  deliveryPlan: getDeliveryPlanVehicleInformation
  splitReturningAndLeavingTime: {
    splitReturningTime: string | null;
    splitLeavingTime: string | null;
  }
  execSplit: () => void
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function exec() {
  props.execSplit();
  modelValue.value = false;
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    modalMaxWidth="45%"
    :title="props.title"
  >
    <template v-slot:content>
      <RegisterModalContent
        :deliveryPlan="props.deliveryPlan"
        :splitReturningAndLeavingTime="splitReturningAndLeavingTime"
      />
    </template>
    <template v-slot:buttons>
      <v-btn
        class="ma-2 reset-btn"
        @click="modelValue = false"
      >
        {{ i18n.global.t('common.cancelBtn') }}
      </v-btn>
      <v-btn
        class="ma-2 exec-btn"
        @click="exec"
      >
        {{ i18n.global.t('pages.dailyReports.splitForm.execute') }}
      </v-btn>
    </template>
  </RegisterModal>
</template>
